// eslint-disable-next-line
import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Home from './Theme/Home.jsx';
import Redirect from './Theme/Redirect.jsx';
import NotFound from './404.jsx';
import Privacy from './Privacy';

const ANYDAY_REDIRECT = true;

class Routes extends React.Component {
	constructor(props) {
		super(props);
		if (!this.props.pages) {
			this.state = { pages: [], isAuthed: false };
		} else {
			this.state = { pages: this.props.pages, isAuthed: false };
		}
	}

	render() {
		if (ANYDAY_REDIRECT) {
			return <Redirect />;
		}

		return (
			<BrowserRouter>
				<Switch>
					<Route exact path="/" component={Home} />
					<Route exact path="/privacy" component={Privacy} />
					<Route exact path="/:section" component={Home} />
					<Route component={NotFound} />
				</Switch>
			</BrowserRouter>
		);
	}
}
export default Routes;



// WEBPACK FOOTER //
// ./src/Routes.jsx